import services from '@/config/services'

export default class SollecitiFattureClientiService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async getAllFattureScadute(opts = {}){
    
    let item = {}

    if(!Object.keys(opts).length){
      opts = 'no-filters'
    }

    const url = `${this.baseUrl}/clienti/fatture/insolute/no-solleciti/search`

    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }

  }

  async getAllFattureInSollecito(opts = {}){
    
    let item = {}

    if(!Object.keys(opts).length){
      opts = 'no-filters'
    }

    const url = `${this.baseUrl}/clienti/fatture/insolute/solleciti/search`

    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }

  }

  async insertFattureToSolleciti(opts){

    let result = false

    const url = `${this.baseUrl}/clienti/fatture/insolute/solleciti`

    try {
      let res = await this.http.post(url, {
        filters: opts
      })
    
      res = res.data

      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        result
      }
    }

  }

  async downloadFileSollecitiZip(opts){
    const url = `${this.baseUrl}/clienti/fatture/insolute/solleciti/zip`
  
    try {
      const res = await this.http({
        url,
        method: 'POST',
        data: {
          filters: opts,
        },
        responseType: 'blob',
      })
      
      const blob = new Blob([res.data], {type: 'application/zip'});
      const fileName= window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')
  
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

}
